module.exports = __webpack_public_path__ + "img/icon-induce-03.53d94c8e.svg";